﻿export default class ApplicationsRebates {
	constructor(init) {
		this.rebateCurrentVehicles = {
			numberOfVehicles: null, // Possible Values: 0, 1, 2, 3, null
			vehicles: [],
		};
		this.rebateReturnedLeaseVehicles = {
			numberOfVehicles: null, // Possible Values: 0, 1, 2, 3, null
			vehicles: [],
		};
		this.rebateMilitary = {
			whoIsMilitary: null, // Possible Values: me, spouse, both, noOne
			militaryBranchSelf: null, // Possible Values: army, navy, airForce, nationalGuard, marines, coastGuard
			militaryStatusSelf: null, // Possible Values: active, veteran, inactive, retired, reservist
			enrollmentDateSelf: null,
			militaryBranchSpouse: null, // Possible Values: army, navy, airForce, nationalGuard, marines, coastGuard
			militaryStatusSpouse: null, // Possible Values: active, veteran, inactive, retired, reservist
			enrollmentDateSpouse: null,
		};
		this.rebateAcademic = {
			isEnrolled: null,
			academicSchoolName: null,
			academicStudentType: null, // Possible Values: fullTime, partTime, graduated, academicLeave
			academicInstitutionType: null, // Possible Values: highSchool, college, university, tradeSchool, registeredNursingSchool, nursingSchool
			enrollmentDate: null,
		};
		this.rebateOrganizations = null; //List Possible Values: nar, ffa, fba, dfa, nari, nfib, nfda (can be empty)

		if (init) {
			if (init.rebateCurrentVehicles) {
				this.rebateCurrentVehicles = init.rebateCurrentVehicles;
			}

			if (init.rebateReturnedLeaseVehicles) {
				this.rebateReturnedLeaseVehicles = init.rebateReturnedLeaseVehicles;
			}

			if (init.rebateMilitary) {
				this.rebateMilitary = init.rebateMilitary;
			}

			if (init.rebateAcademic) {
				this.rebateAcademic = init.rebateAcademic;
			}

			if (init.rebateOrganizations) {
				this.rebateOrganizations = init.rebateOrganizations;
			}
		}
	}
}
